import { useTranslation } from 'react-i18next';

import { ABOUT_TEAM_MEMBERS } from './landing-about-team';
import { LandingReveal } from './landing-shared';

export const LandingAboutTeamSection = () => {
  const { t } = useTranslation('landing');

  return (
    <section className="border-t border-white/35 py-12 sm:py-16" aria-labelledby="about-team-heading">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <LandingReveal>
          <h2
            id="about-team-heading"
            className="landing-display text-center text-[1.5rem] font-semibold tracking-tight text-on-brand"
          >
            {t('about.teamTitle')}
          </h2>
        </LandingReveal>

        <ul className="mt-10 flex flex-wrap justify-center gap-8 sm:gap-10">
          {ABOUT_TEAM_MEMBERS.map(({ id, photo }, index) => (
            <LandingReveal key={id} as="li" delayMs={index * 60} className="w-44 sm:w-52">
              <article className="text-center">
                <div className="overflow-hidden rounded-2xl border border-white/20 bg-white/8">
                  <img
                    src={photo}
                    alt={t(`about.team.members.${id}.photoAlt`)}
                    className="aspect-[4/5] w-full object-cover object-[center_15%]"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <p className="mt-3 text-card-title font-semibold text-on-brand">
                  {t(`about.team.members.${id}.name`)}
                </p>
              </article>
            </LandingReveal>
          ))}
        </ul>
      </div>
    </section>
  );
};
